const env = require('../env');
const webhookEvents = [
    {
        text: '新規メッセージを受信',
        value: 'message.received'
    },
    {
        text: 'BOCCO emoが音声コマンドを認識',
        value: 'vui_command.detected'
    },
    {
        text: 'BOCCO emoの前に人が近づいた',
        value: 'radar.detected'
    },
    {
        text: '振動センサが反応した',
        value: 'movement_sensor.detected'
    },
    {
        text: '鍵センサが反応した',
        value: 'lock_sensor.detected'
    },
    {
        text: '人感センサが反応した',
        value: 'human_sensor.detected'
    },
    {
        text: '部屋センサが反応した',
        value: 'room_sensor.detected'
    }
    /*
    {
        text: 'BOCCOボタンが反応した',
        value: 'bocco_button.detected'
    },
    */
];
const messages = {
    unauthorized: '不明なエラーが発生しました。ページをリロードして、再設定してください。作業途中の場合は、保存してからリロードしてくだい。'
};
// sensor_actionのキーと日本語表記の対応（bocco-emo-server の sensor message 定義に準拠）
const sensorActions = {
    'door': '反応があった',
    'human': '反応があった',
    'appear': '近づいた',
    'disappear': '離れた',
    'key-on': '鍵が閉まった',
    'key-off': '鍵が開いた',
    'cold': '寒くなった',
    'dry': '乾燥している',
    'humid': '多湿になった',
    'normal': '通常に戻った',
    'brighter': '明るくなった',
    'darker': '暗くなった',
    'heat-warn-medium': '熱中症警戒度「中」',
    'heat-warn-high': '熱中症警戒度「高」',
    'heat_warn_medium': '熱中症警戒度「中」',
    'heat_warn_high': '熱中症警戒度「高」',
    'tempra': '温湿度の通知'
};

if (env === 'production'){
    module.exports = {
        baseUrl: 'https://platform-api.bocco.me',
        websocketUrl: 'wss://di917v88rc.execute-api.ap-northeast-1.amazonaws.com/v1',
        motions: [
            {
                text: 'Bonbori_short',
                value: 'fa0beb73-ce8f-4786-9c0b-05ea5da9f125'
            },
            {
                text: 'Blighten_Hi',
                value: '1ff3892d-1e97-4676-b2e5-e1344a4152a7'
            },
            {
                text: 'Cold_Hi',
                value: '75c81186-4668-4549-85de-7c376d15ee2d'
            },
            {
                text: 'GoodNight_Lo',
                value: '6f047995-ab51-452c-b869-009ddf77c08b'
            },
            {
                text: 'Dark',
                value: '69b71502-c472-4902-849f-4b78aae28bb8'
            },
            {
                text: 'GoodMorning_Lo',
                value: '50256a22-6585-4737-af5d-7031df91275c'
            },
            {
                text: 'GoodNight_Hi',
                value: '341b1ae6-6cce-4507-b63c-3d987af611b2'
            },
            {
                text: 'Goo',
                value: 'b8ab2bc4-1d44-4313-a150-c3566cf8d756'
            },
            {
                text: 'Cold_Lo',
                value: '16fd7a0a-8e8b-480f-98a6-33205924b6a0'
            },
            {
                text: 'GoodMorning_Hi',
                value: '421f0292-ee55-41f6-a116-0c377345068c'
            },
            {
                text: 'Event_start_pink',
                value: 'eaf4a956-7d35-4e80-9901-0f83716ffb69'
            },
            {
                text: 'Event_end_pink',
                value: '1154e98a-d4be-4b07-aefa-0e1585a3e72a'
            },
            {
                text: 'Hello_Lo',
                value: 'ccab5093-7ad0-4555-a62d-2617449958fe'
            },
            {
                text: 'Hello_Hi',
                value: '4a5785fd-6082-4a4f-990e-fb61e0cbeb8b'
            },
            {
                text: 'Hot_Lo',
                value: '3a299389-641e-44d7-9785-208ab557b07b'
            },
            {
                text: 'Hot_Hi',
                value: 'e01c10f2-d680-49fd-8db9-dcb934ff6d68'
            },
            {
                text: 'Meal_Hi',
                value: 'df0ab9e0-7a5b-4668-9ed3-22374de55fc9'
            },
            {
                text: 'Meal_Lo',
                value: 'c5eb760d-58f8-4cea-9fb1-37abb8c1d48b'
            },
            {
                text: 'Snooze_3',
                value: '45ef0943-7600-470a-8b90-b811b9ba4500'
            },
            {
                text: 'Pii',
                value: '8d8fcdc6-b256-4c5e-9ce3-357834d85148'
            },
            {
                text: 'Snooze_1',
                value: 'c5c6a6d6-0982-4d90-8407-543e1a30739a'
            },
            {
                text: 'Snooze_2',
                value: 'a2755266-e6d2-4401-b1b5-f86b6950ed4a'
            },
            {
                text: 'WiFi_Setup_2',
                value: '7259e868-98f6-4054-ae8e-f43b854d4062'
            },
            {
                text: 'WiFi_Setup_1',
                value: 'd0b553e2-e5c8-4d79-82b9-4a4da519ca8b'
            },
            {
                text: 'WiFi_Setup_3',
                value: 'fa9374da-dd6b-4c2c-90f2-21a4c086b2e8'
            },
            {
                text: 'Yoisho',
                value: 'b15fee60-fc3a-4ce0-9aa7-711f20cf511c'
            },
            {
                text: 'gochisousama_Lo',
                value: 'f2d71837-0738-4191-a390-d1027e77cd92'
            },
            {
                text: 'gochisousama_Hi',
                value: '52ddb421-9356-4529-973a-b975e9fdd8c0'
            },
            {
                text: 'ittekimasu_Hi',
                value: '2819d158-a6f3-4680-8d55-163121d29325'
            },
            {
                text: 'ittekimasu_Lo',
                value: 'bdbb6ec5-883a-4d28-a28e-ebf16faf5dec'
            },
            {
                text: 'message_3',
                value: 'fd95226f-2c86-4c1f-b28d-03aff062a2e4'
            },
            {
                text: 'message_2',
                value: '0fe1266e-607d-4ebb-848a-f8b962a5819b'
            },
            {
                text: 'message_1',
                value: '84274b1e-f4c1-4def-a6d3-08915f316f20'
            },
            {
                text: 'moshimoshi_C',
                value: 'b642b7a2-6710-4c50-859e-b8e3b48fb510'
            },
            {
                text: 'moshimoshi_L',
                value: '569de42e-56f2-4222-bec2-a98e4ceb3c29'
            },
            {
                text: 'moshimoshi_R',
                value: '1d8c3d72-99a6-417b-a33d-ce48b5de5108'
            },
            {
                text: 'tadaima_Hi',
                value: 'ecdf3700-cb73-4f7b-bb37-3e85525ea88f'
            },
            {
                text: 'tadaima_Lo',
                value: '37de062e-dcd0-4663-ae89-1273f758005a'
            },
            {
                text: 'zzz',
                value: 'f22970a8-7d1c-498b-942a-885a7f19c4f0'
            },
            {
                text: 'BUNBUN',
                value: '47d6efd8-6aba-44c3-9718-f071265646ee'
            },
            {
                text: 'Rain_Little',
                value: 'cb230b35-9f3b-46db-8c55-fb2027e1f6e9'
            },
            {
                text: 'Rain_Middle',
                value: '21bd84b9-c979-4d35-a8e3-a6cee12d37e1'
            },
            {
                text: 'Cloudy',
                value: 'cb1b7ded-4b22-47a5-a716-f7a8b9bb6b7a'
            },
            {
                text: 'Sunny',
                value: '488a339b-410e-460c-965b-eb5aad454622'
            },
            {
                text: 'Rain_Hard',
                value: '95e47680-c6f3-476f-8e74-16f0792e31b9'
            },
            {
                text: 'Timer_End',
                value: '61232350-ee85-47e1-9c29-3069d0de1ac0'
            },
            {
                text: 'Timer_Start',
                value: '59918bd8-0d75-4b77-a3ac-7f726d52f5b0'
            },
            {
                text: 'App_Setup',
                value: 'e6655ea1-e825-4cc3-80ea-e74201b1229e'
            },
            {
                text: 'NiceToMeetYou_Hi',
                value: '3fe2031d-1c54-40ea-a6bd-a16e4cef8455'
            },
            {
                text: 'Color_Check_0.1sec',
                value: '7d5d319f-a13a-48b1-95a2-95fde15d0c9f'
            },
            {
                text: 'Foo',
                value: '3fe6c0a3-41b8-4754-b37b-ba69c18af313'
            },
            {
                text: 'Color_Check_1sec',
                value: '1c2873a3-7bf7-449a-a854-2bb0a67b0e5e'
            },
            {
                text: 'Color_Check_2sec',
                value: '1d35f044-2444-4670-8942-d6f97f1fbaf6'
            },
            {
                text: 'NiceToMeetYou_Lo',
                value: '73586f25-91b3-4cd2-a44f-08c82ce41b02'
            },
            {
                text: 'Blighten_Little',
                value: '7685245c-f735-4857-928d-213c97896ee1'
            },
            {
                text: 'happybirthday',
                value: '859302fe-b2e5-41ce-b5b0-6eeee5b9625b'
            }
        ],
        webhookEvents: webhookEvents,
        sensorActions: sensorActions,
        refreshToken: '',
        messages: messages
    };
} else {
    module.exports = {
        baseUrl: 'https://staging-platform-api.bocco.me',
        websocketUrl: 'wss://2hep1rv5w4.execute-api.ap-northeast-1.amazonaws.com/v1',
        motions: [
            {
                text: 'Bonbori_short',
                value: 'fa0beb73-ce8f-4786-9c0b-05ea5da9f125'
            },
            {
                text: 'Blighten_Hi',
                value: '1ff3892d-1e97-4676-b2e5-e1344a4152a7'
            },
            {
                text: 'Cold_Hi',
                value: '75c81186-4668-4549-85de-7c376d15ee2d'
            },
            {
                text: 'GoodNight_Lo',
                value: '6f047995-ab51-452c-b869-009ddf77c08b'
            },
            {
                text: 'Dark',
                value: '69b71502-c472-4902-849f-4b78aae28bb8'
            },
            {
                text: 'GoodMorning_Lo',
                value: '50256a22-6585-4737-af5d-7031df91275c'
            },
            {
                text: 'GoodNight_Hi',
                value: '341b1ae6-6cce-4507-b63c-3d987af611b2'
            },
            {
                text: 'Goo',
                value: 'b8ab2bc4-1d44-4313-a150-c3566cf8d756'
            },
            {
                text: 'Cold_Lo',
                value: '16fd7a0a-8e8b-480f-98a6-33205924b6a0'
            },
            {
                text: 'GoodMorning_Hi',
                value: '421f0292-ee55-41f6-a116-0c377345068c'
            },
            {
                text: 'Event_start_pink',
                value: 'eaf4a956-7d35-4e80-9901-0f83716ffb69'
            },
            {
                text: 'Event_end_pink',
                value: '1154e98a-d4be-4b07-aefa-0e1585a3e72a'
            },
            {
                text: 'Hello_Lo',
                value: 'ccab5093-7ad0-4555-a62d-2617449958fe'
            },
            {
                text: 'Hello_Hi',
                value: '4a5785fd-6082-4a4f-990e-fb61e0cbeb8b'
            },
            {
                text: 'Hot_Lo',
                value: '3a299389-641e-44d7-9785-208ab557b07b'
            },
            {
                text: 'Hot_Hi',
                value: 'e01c10f2-d680-49fd-8db9-dcb934ff6d68'
            },
            {
                text: 'Meal_Hi',
                value: 'df0ab9e0-7a5b-4668-9ed3-22374de55fc9'
            },
            {
                text: 'Meal_Lo',
                value: 'c5eb760d-58f8-4cea-9fb1-37abb8c1d48b'
            },
            {
                text: 'Snooze_3',
                value: '45ef0943-7600-470a-8b90-b811b9ba4500'
            },
            {
                text: 'Pii',
                value: '8d8fcdc6-b256-4c5e-9ce3-357834d85148'
            },
            {
                text: 'Snooze_1',
                value: 'c5c6a6d6-0982-4d90-8407-543e1a30739a'
            },
            {
                text: 'Snooze_2',
                value: 'a2755266-e6d2-4401-b1b5-f86b6950ed4a'
            },
            {
                text: 'WiFi_Setup_2',
                value: '7259e868-98f6-4054-ae8e-f43b854d4062'
            },
            {
                text: 'WiFi_Setup_1',
                value: 'd0b553e2-e5c8-4d79-82b9-4a4da519ca8b'
            },
            {
                text: 'WiFi_Setup_3',
                value: 'fa9374da-dd6b-4c2c-90f2-21a4c086b2e8'
            },
            {
                text: 'Yoisho',
                value: 'b15fee60-fc3a-4ce0-9aa7-711f20cf511c'
            },
            {
                text: 'gochisousama_Lo',
                value: 'f2d71837-0738-4191-a390-d1027e77cd92'
            },
            {
                text: 'gochisousama_Hi',
                value: '52ddb421-9356-4529-973a-b975e9fdd8c0'
            },
            {
                text: 'ittekimasu_Hi',
                value: '2819d158-a6f3-4680-8d55-163121d29325'
            },
            {
                text: 'ittekimasu_Lo',
                value: 'bdbb6ec5-883a-4d28-a28e-ebf16faf5dec'
            },
            {
                text: 'message_3',
                value: 'fd95226f-2c86-4c1f-b28d-03aff062a2e4'
            },
            {
                text: 'message_2',
                value: '0fe1266e-607d-4ebb-848a-f8b962a5819b'
            },
            {
                text: 'message_1',
                value: '84274b1e-f4c1-4def-a6d3-08915f316f20'
            },
            {
                text: 'moshimoshi_C',
                value: 'b642b7a2-6710-4c50-859e-b8e3b48fb510'
            },
            {
                text: 'moshimoshi_L',
                value: '569de42e-56f2-4222-bec2-a98e4ceb3c29'
            },
            {
                text: 'moshimoshi_R',
                value: '1d8c3d72-99a6-417b-a33d-ce48b5de5108'
            },
            {
                text: 'tadaima_Hi',
                value: 'ecdf3700-cb73-4f7b-bb37-3e85525ea88f'
            },
            {
                text: 'tadaima_Lo',
                value: '37de062e-dcd0-4663-ae89-1273f758005a'
            },
            {
                text: 'zzz',
                value: 'f22970a8-7d1c-498b-942a-885a7f19c4f0'
            },
            {
                text: 'BUNBUN',
                value: '47d6efd8-6aba-44c3-9718-f071265646ee'
            },
            {
                text: 'Rain_Little',
                value: 'cb230b35-9f3b-46db-8c55-fb2027e1f6e9'
            },
            {
                text: 'Rain_Middle',
                value: '21bd84b9-c979-4d35-a8e3-a6cee12d37e1'
            },
            {
                text: 'Cloudy',
                value: 'cb1b7ded-4b22-47a5-a716-f7a8b9bb6b7a'
            },
            {
                text: 'Sunny',
                value: '488a339b-410e-460c-965b-eb5aad454622'
            },
            {
                text: 'Rain_Hard',
                value: '95e47680-c6f3-476f-8e74-16f0792e31b9'
            },
            {
                text: 'Timer_End',
                value: '61232350-ee85-47e1-9c29-3069d0de1ac0'
            },
            {
                text: 'Timer_Start',
                value: '59918bd8-0d75-4b77-a3ac-7f726d52f5b0'
            },
            {
                text: 'App_Setup',
                value: 'e6655ea1-e825-4cc3-80ea-e74201b1229e'
            },
            {
                text: 'NiceToMeetYou_Hi',
                value: '3fe2031d-1c54-40ea-a6bd-a16e4cef8455'
            },
            {
                text: 'Color_Check_0.1sec',
                value: '7d5d319f-a13a-48b1-95a2-95fde15d0c9f'
            },
            {
                text: 'Foo',
                value: '3fe6c0a3-41b8-4754-b37b-ba69c18af313'
            },
            {
                text: 'Color_Check_1sec',
                value: '1c2873a3-7bf7-449a-a854-2bb0a67b0e5e'
            },
            {
                text: 'Color_Check_2sec',
                value: '1d35f044-2444-4670-8942-d6f97f1fbaf6'
            },
            {
                text: 'NiceToMeetYou_Lo',
                value: '73586f25-91b3-4cd2-a44f-08c82ce41b02'
            },
            {
                text: 'Blighten_Little',
                value: '7685245c-f735-4857-928d-213c97896ee1'
            },
            {
                text: 'happybirthday',
                value: '3830006f-c8b4-44fb-897c-cb1fc980368f'
            }
        ],
        webhookEvents: webhookEvents,
        sensorActions: sensorActions,
        refreshToken: '7bba6349-fdbb-4389-8d85-97bc2c215911',
        messages: messages
    };
}
